import { useNavigate } from 'react-router-dom';
import {
  PRIMARY,
  TEXT_DARK,
  TEXT_MUTED,
  BG_CARD,
  BORDER_LIGHT,
  FONT_HEADING,
} from '../components/legacy-ball/table-management/designTokens';

/**
 * BookletMemorialTilesPage — Displays memorial tiles (images not yet available).
 * Placeholder page with 4 tile slots awaiting images.
 */
export function BookletMemorialTilesPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <button style={styles.backBtn} onClick={() => navigate(-1)}>← Back</button>
      <h1 style={styles.title}>🕊️ Memorial Tiles</h1>
      <p style={styles.subtitle}>In loving memory — tiles honoring those we cherish</p>

      <div style={styles.grid}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} style={styles.tilePlaceholder}>
            <span style={styles.placeholderIcon}>🕊️</span>
            <span style={styles.placeholderText}>Image {i}</span>
            <span style={styles.comingSoon}>Coming Soon</span>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { padding: '1.5rem', minHeight: '100%', maxWidth: '600px', margin: '0 auto' },
  title: { fontFamily: FONT_HEADING, fontSize: '1.5rem', fontWeight: 700, color: TEXT_DARK, margin: '0.5rem 0 0.25rem' },
  subtitle: { color: TEXT_MUTED, fontSize: '0.85rem', marginBottom: '1.25rem' },
  backBtn: { background: 'none', border: 'none', color: PRIMARY, fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', padding: '4px 0', marginBottom: '0.5rem', display: 'block' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  tilePlaceholder: {
    backgroundColor: BG_CARD,
    border: `2px dashed ${BORDER_LIGHT}`,
    borderRadius: '10px',
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    minHeight: '140px',
  },
  placeholderIcon: { fontSize: '2rem' },
  placeholderText: { fontSize: '0.8rem', color: TEXT_MUTED, fontWeight: 500 },
  comingSoon: { fontSize: '0.65rem', color: PRIMARY, fontWeight: 600, backgroundColor: '#f0fdf4', padding: '2px 8px', borderRadius: '10px' },
};
